import { TransactionType, Permission } from '../../graphql'

//import { Permissions } from "./constants";

const FROM_STORE_TYPES = new Set( [
	TransactionType.StoreToProvider,
	TransactionType.StoreToRetailSale,
	TransactionType.StoreToLoss,
	TransactionType.StoreToStore,
	TransactionType.StoreToWorkOrder,
	TransactionType.StoreToObsolete,
] )

export function isFromStore( type: TransactionType ): boolean {
	return FROM_STORE_TYPES.has( type )
}

const FROM_PROVIDER_TYPES = new Set( [
	TransactionType.ProviderToStore,
] )

export function isFromProvider( type: TransactionType ): boolean {
	return FROM_PROVIDER_TYPES.has( type )
}

const FROM_RETAIL_SALE = new Set( [
	TransactionType.RetailSaleToStore,
] )

export function isFromRetailSale( type: TransactionType ): boolean {
	return FROM_RETAIL_SALE.has( type )
}

const FROM_WORK_ORDER = new Set( [
	TransactionType.WorkOrderToStore,
] )

export function isFromWorkOrder( type: TransactionType ): boolean {
	return FROM_WORK_ORDER.has( type )
}

const TO_STORE_TYPES = new Set( [
	TransactionType.ProviderToStore,
	TransactionType.RetailSaleToStore,
	TransactionType.StoreToStore,
	TransactionType.WorkOrderToStore,
] )

export function isToStore( type: TransactionType ): boolean {
	return TO_STORE_TYPES.has( type )
}

const TO_PROVIDER_TYPES = new Set( [
	TransactionType.StoreToProvider,
] )

export function isToProvider( type: TransactionType ): boolean {
	return TO_PROVIDER_TYPES.has( type )
}

const TO_WORK_ORDER_TYPES = new Set( [
	TransactionType.StoreToWorkOrder,
] )

export function isToWorkOrder( type: TransactionType ): boolean {
	return TO_WORK_ORDER_TYPES.has( type )
}

const TO_RETAIL_SALE_TYPES = new Set( [
	TransactionType.StoreToRetailSale,
] )

export function isToRetailSale( type: TransactionType ): boolean {
	return TO_RETAIL_SALE_TYPES.has( type )
}

const TO_LOSS_TYPES = new Set( [
	TransactionType.StoreToLoss,
] )

export function isToLoss( type: TransactionType ): boolean {
	return TO_LOSS_TYPES.has( type )
}

const TO_OBSOLETE_TYPES = new Set( [
	TransactionType.StoreToObsolete,
] )

export function isToObsolete( type: TransactionType ): boolean {
	return TO_OBSOLETE_TYPES.has( type )
}

const TYPE_TO_HUMAN_READABLE: { [ key: string ]: string } = {
	[ TransactionType.ProviderToStore ]: 'Purchase Order',
	[ TransactionType.StoreToProvider ]: 'Returned Purchase Order',
	[ TransactionType.StoreToRetailSale ]: 'Retail Sale',
	[ TransactionType.RetailSaleToStore ]: 'Retail Sale Return',
	[ TransactionType.StoreToLoss ]: 'Loss',
	[ TransactionType.StoreToStore ]: 'Transfer',
	[ TransactionType.StoreToWorkOrder ]: 'Items for Work Order',
	[ TransactionType.StoreToObsolete ]: 'Items are obsolete',
	[ TransactionType.WorkOrderToStore ]: 'Remove items from a Work Order',
}

export function typeToFriendly( type: TransactionType ): string | null {
	return TYPE_TO_HUMAN_READABLE[ type ] || null
}

export function toStorePermissionFilter( type: TransactionType ): Permission[] | null {
	switch ( type ) {
		case TransactionType.ProviderToStore:
			return [ Permission.CanSubmitPurchaseOrderByStoreId ]

		case TransactionType.RetailSaleToStore:
			return [ Permission.CanRecordRetailSaleReturnByStoreId ]

		case TransactionType.WorkOrderToStore:
			return [ Permission.CanApprovePartsRemovalFromWorkOrderByStoreId ]

		case TransactionType.StoreToStore:
			// return everything
			return null

		default:
			// don't show anything by default
			return []
	}
}

export function fromStorePermissionFilter( type: TransactionType ): Permission[] {
	switch ( type ) {
		case TransactionType.StoreToProvider:
			return [ Permission.CanSubmitPartsReturnByStoreId ]

		case TransactionType.StoreToRetailSale:
			return [ Permission.CanRecordRetailSaleByStoreId ]

		case TransactionType.StoreToLoss:
			return [ Permission.CanRecordPartLossByStoreId ]

		case TransactionType.StoreToStore:
			return [ Permission.CanSubmitPartsTransferByStoreId ]

		case TransactionType.StoreToWorkOrder:
			return [ Permission.CanRequestPartsOnWorkOrderByStoreId ]

		case TransactionType.StoreToObsolete:
			return [ Permission.CanRecordPartObsoleteByStoreId ]

		default:
			return []
	}
}

export const NULLABLE_TO_ID_TYPES = [
	TransactionType.StoreToRetailSale,
	TransactionType.StoreToLoss,
	TransactionType.StoreToObsolete,
]

export function validateToId( type: TransactionType, toId: number | null | undefined ): boolean {
	return Number.isInteger( toId ) || NULLABLE_TO_ID_TYPES.includes( type )
}

export const NULLABLE_FROM_ID_TYPES = [
	TransactionType.RetailSaleToStore,
]

export function validateFromId( type: TransactionType, fromId: number | null | undefined ): boolean {
	return Number.isInteger( fromId ) || NULLABLE_FROM_ID_TYPES.includes( type )
}
